"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var filesaverjs_1 = require("filesaverjs");
var papaparse_1 = __importDefault(require("papaparse"));
var BluePrintService = (function () {
    function BluePrintService($http, user, alfredApiBaseUrl, notifyUser, bluePrintBatchLimit) {
        this.$http = $http;
        this.user = user;
        this.alfredApiBaseUrl = alfredApiBaseUrl;
        this.notifyUser = notifyUser;
        this.bluePrintBatchLimit = bluePrintBatchLimit;
    }
    BluePrintService.prototype.build = function (project, templateData) {
        if (!project.links || !project.links[0] || !project.links[0].secret) {
            throw new Error("This project has no valid secret link");
        }
        if (templateData.length > this.bluePrintBatchLimit) {
            return this.notifyUser.error("You cannot create more than ".concat(this.bluePrintBatchLimit, " pages at once."));
        }
        var linkSecret = project.links[0].secret;
        return this.$http({
            method: "POST",
            url: "".concat(this.alfredApiBaseUrl, "/projects?batch"),
            headers: {
                Authorization: "Bearer ".concat(this.user.apiKey),
            },
            data: {
                secret: linkSecret,
                data: templateData,
            },
        }).then(function (response) {
            return response.data;
        });
    };
    BluePrintService.prototype.getOutputFile = function (data, options) {
        if (options == null) {
            options = {};
        }
        if (data == null || !data.length) {
            throw new Error("Missing data for output file.");
        }
        if (options.type == null) {
            options.type = "csv";
        }
        if (options.filename == null) {
            options.filename = "data";
        }
        if (options.type !== "csv" && options.type !== "txt") {
            throw new Error("Trying to create an unsupported file type");
        }
        var csvData = papaparse_1.default.unparse(data);
        var csvBlob = new Blob([csvData], { type: "text/".concat(options.type, ";charset=utf-8") });
        return (0, filesaverjs_1.saveAs)(csvBlob, "".concat(options.filename, ".").concat(options.type));
    };
    return BluePrintService;
}());
exports.default = BluePrintService;
